import React from 'react';
import BusinessIcon from '@mui/icons-material/Business';
import DOMPurify from 'dompurify';

const SearchPreviewResultCompany = ({ company, isSelected, onClick, isClickingPreviewItemRef }) => {
    const renderLogo = () => {
        if (!company.logo) {
            return <BusinessIcon style={{ fontSize: '16px' }} />;
        }

        if (typeof company.logo === 'string' && company.logo.trim().startsWith('<svg')) {
            const sanitizedLogo = DOMPurify.sanitize(company.logo, {
                USE_PROFILES: { svg: true, svgFilters: true }
            });
            return (
                <div
                    className="company-logo-svg"
                    dangerouslySetInnerHTML={{ __html: sanitizedLogo }}
                />
            );
        }

        return (
            <img
                src={`${company.logo}?token=pk_LWbmMF36Rqe5UN5m-r0iFg`}
                alt={company.name}
                className="company-logo"
            />
        );
    };

    const handleMouseDown = () => {
        if (isClickingPreviewItemRef) {
            isClickingPreviewItemRef.current = true;
            console.log('[SearchPreviewResultCompany] Mouse down, setting flag.');
        }
    };

    return (
        <div 
            className={`company-result ${isSelected ? 'selected' : ''}`}
            onClick={() => onClick?.(company)}
            onMouseDown={handleMouseDown}
        >
            <div className="company-logo-wrapper">
                {renderLogo()}
            </div>
            <div className="company-name">{company.name}</div>
            {company.ticker && (
                <span className="company-ticker">{company.ticker}</span>
            )}
        </div>
    );
};

export default SearchPreviewResultCompany;
